import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../assets/image6.jpg';
import maskImage from '../assets/gimage1.gif';

function Contact() {
  const { t } = useTranslation();
  const [showMask, setShowMask] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMask(false);
    }, 5800); // 5.8 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-black">
      <div
        className="absolute inset-0 w-full h-full transition-all duration-300 bg-black"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          ...(showMask && {
            WebkitMaskImage: `url(${maskImage})`,
            maskImage: `url(${maskImage})`,
            WebkitMaskSize: 'cover',
            maskSize: 'cover',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
          }),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      {/* Black background section with contact text */}
      <div className="absolute bottom-0 w-full bg-black text-white py-12 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-lg mb-6">
            {t('contact.text.line1')}
            <br />
            {t('contact.text.line2')}
          </p>
          
          <div className="h-4" />
          
          <a 
            href="mailto:confesz@tech-center.com"
            className="clickable text-slate-400 hover:text-slate-300 transition-colors duration-300 underline underline-offset-2"
          >
            confesz@tech-center.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;